import React, { ChangeEvent, FormEvent, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { AppRootState } from '../../app/store'
import { WorkItemTitle } from '../Task/WorkItemTitle'
import { addPictureToSystemInfoTC, clearNewTask, createNewTaskTC, NewTaskType, setNewTaskSystemInfoAC, setNewTaskTitle, setPriorityAC, setProjectName, setTabNewTask } from './newTask-reducer'
import { Button, Grid, Tooltip, Typography } from '@mui/material';
import { SelectStatusvalue } from './SelectStatusvalue'
import { NewTaskAttachments } from './NewTaskAttachments'
import { useLocation, useNavigate } from 'react-router-dom'
import { HistoryStateType } from '../TasksList/WorkItemsList'
import { clearAttachmentState, FileType } from './newTaskAttachments-reducer'
import {ContentEditableInfo} from './ContentEditableInfo'
import { checkAutoLogin } from '../Login/auth-reducer'
import { setAppStatusAC } from '../../app/app-reducer'
import { setCurrentLocation } from '../../app/cookies'
import { AlertInfoSaveTask } from '../common/AlertInfoSaveTask'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { ContentEditableInfoForNewTask } from './ContentEditableInfoForNewTask'

export const NewTaskData = React.memo(() => {
  const location = useLocation();
  const stateFromHistory = location.state as HistoryStateType
  const projectName = stateFromHistory.projectName as string
  const projectId: number = stateFromHistory.projectId 
  const [isActive, setButton] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isLoggedIn = useSelector<AppRootState, boolean>(state => state.auth.isLoggedIn)
  const openedTab = useSelector<AppRootState, string>(state => state.newTask.openedTab)
  const newTask = useSelector<AppRootState, NewTaskType>(state => state.newTask.taskData)
  let relations = useSelector<AppRootState, Array<FileType>>(state => state.newTaskAttachments.relations )
  const systemInfo = useSelector<AppRootState, string>(state => state.newTask.taskData.systemInfo )
  const isNewTask = useSelector<AppRootState, boolean>(state => state.workItems.isNewTask)
  const newTaskID = useSelector<AppRootState, number>(state => state.workItems.newTaskID)
 

  useEffect(() => {
    let token = checkAutoLogin(dispatch, false)
    if (token === null && isLoggedIn === false) {
      return navigate('/login')
    } else {
      if(token !== null && isLoggedIn === false){
        return navigate(`/project/${projectName}`)
      }
    }
    dispatch(setAppStatusAC({ status: 'loading' }))
    setCurrentLocation(`\\ Projects \\ ${stateFromHistory.projectName} \\ New Item `)
    dispatch(setProjectName({name: projectName}))
    dispatch(setAppStatusAC({ status: 'succeeded' }))

    return () => {
      dispatch(setTabNewTask({ tabName: 'details' }))
      dispatch(clearNewTask({title: ''}))
      dispatch(clearAttachmentState())
    }
  }, [isLoggedIn])

  const setTitle = (event: FormEvent<HTMLInputElement>) => {
    setButton(true)
    dispatch(setNewTaskTitle({ title: event.currentTarget.value }))
  }

  const setSystemIhfoText = useCallback((htmlNew:string) => {
    dispatch(setNewTaskSystemInfoAC ({ systemInfo: htmlNew }))
  }, [dispatch])

  const addPictureToSystemInfo = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    let file: any
    if (event.target.files) {
      file = event.target.files[0]
      let formData = new FormData()
      formData.append("formdata", file)
      const imgSrc =  URL.createObjectURL(file)
      console.log(file)
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/bmp') {
        dispatch(addPictureToSystemInfoTC({imgSrc, projectId:stateFromHistory.projectId, projectName: projectName, fileName: file.name, formData }))
      } else {
        alert('Unsupported file type.  Valid file types are:  jpg, jpeg, png, bmp, gif')
      }
    }
  }, [])

  const setPriorityinState = (value: number) => {
    dispatch(setPriorityAC({value}))
  }

  async function createNewTask() {
   await dispatch(createNewTaskTC({projectName, projectId}))
    return navigate(`/project/${projectName}`)
  }

  const locationState  = {
    itemID: newTaskID ,
    projectName: projectName,
    projectId: stateFromHistory.projectId
  }
 
  if(!isLoggedIn) {
    navigate('/login')
  }
  return <>
    <Grid container spacing={3} >
      <Grid item xl={12} xs={12}>
      <Grid style={{ paddingTop: '30px' }}>
          <Button onClick={(e) => navigate(`/project/${projectName}`)} color='info' className='addItemButton' startIcon={<KeyboardReturnIcon style={{ color: 'grey' }} fontSize='medium' />}>
          Back to Work Items
          </Button>
        </Grid>
        <Grid container style={{ marginTop: '40px', width: '100%'}}>
          <Grid style={{
            maxWidth: '12px',
            backgroundColor: 'rgb(204, 41, 61)'
          
          }} item md={1} xs={1}>
          </Grid>
          <Grid item className='itemCard' style={{ minWidth: 'calc(100% - 12px)'}} md={11} xs={11}>
            <WorkItemTitle workType={'Bug'} id={1} />
            {newTask.title === '' ?
       
                 <span style={{color:'red', fontSize:'12px'}}> Field 'Title' cannot be empty </span> 
      
           
                                  : <span style={{visibility: 'hidden', color:'red', fontSize:'12px'}}>Field 'Title' cannot be empty </span> }
            
            <div className='combo'>
              <div className='enterWrap'>
                {'  '}
                <Tooltip placement="top-start" title="Please enter a meaningful Title, which allows everyone to immediately know what the bug is about. 
            Bad examples: Error Message, Error 404, Join Not working, ... 
            Good examples: Error 404 when trying to join a meeting with appointment, PSTN call drops when trying to enter meeting id, ... 
            ">
                <input id='enterTitle' type='text' autoComplete='off' value={newTask.title} placeholder='Enter title ...' onInput={(e) => { setTitle(e) }} />
                </Tooltip>
              </div>
            </div>
            <Grid container style={{justifyContent: 'flex-end', paddingBottom: '10px', paddingTop:'10px' }}>
            <AlertInfoSaveTask isActive={isActive} isOpen={newTask.title === ''} createNewTask = {createNewTask} text="Field 'Title' cannot be empty!" />
            </Grid>
          </Grid>
        </Grid>
        <Grid className='itemInfo' container >
          <Grid item md={1} xs={6}>
            <Typography variant="caption" style={{ color: 'grey' }}>
              Stat<u>e</u> {' '}
            </Typography>
            <div>
              <Typography variant="caption" style={{ color: 'grey' }}>
                Priority {' '}
              </Typography>
            </div>
          </Grid>
          <Grid item md={2} xs={6} >
            <Typography variant="body2" style={{ display: 'inline-flex', alignItems: 'center' }}>
              <div style={{
                border: ' 1px solid', marginRight: '10px', width: '11px', height: '11px',
                backgroundColor: 'rgb(178, 178, 178)', borderRadius: '50%',
                borderColor: 'rgb(178, 178, 178)'
              }}></div>
              {newTask.status}
            </Typography>
            <Tooltip placement="top-start" title="It should be stated how serious the error is. Is it a minor cosmetic error, or does it prevent the use of the software completely.">
            <Typography variant="body2">
              <SelectStatusvalue setPriorityinState={setPriorityinState} priority={newTask.priority} />
            </Typography>
            </Tooltip>
           
           <span style={{color:'red', fontSize:'12px'}}>Set the priority above!</span> 
          </Grid>
          <Grid item md={1} xs={6}>
            <Typography variant="caption" style={{ color: 'grey' }}>
              <u>A</u>rea {' '}
            </Typography>
          </Grid>
          <Grid item md={2} xs={6}>
            <Typography variant="body2">
              {projectName}
            </Typography>
          </Grid>
          <Grid className='itemInfoDetails' container >
            <Grid onClick={() => dispatch(setTabNewTask({ tabName: 'details' }))} item className={openedTab === 'details' 
                                                                                                 ? 'details detailsActive' : 'details'}>
              Details
            </Grid>
            <Grid onClick={() => dispatch(setTabNewTask({ tabName: 'attachments' }))} item className={openedTab === 'attachments' 
                                                                                                      ? 'details detailsActive' : 'details'}>
              <AttachFileIcon fontSize="small" />
              <span  style={{fontSize: '14px'}}>
                 {relations.length > 0 ? `(${relations.length})` : ''}
              </span>
            </Grid>
          </Grid>
        </Grid>
        {openedTab === 'attachments' ? <NewTaskAttachments projectId={stateFromHistory.projectId} projectName={projectName} />
          :
          <>
          <Grid container className='retroSteps' >
          <Typography className='titleHover' >
                <b>System Info</b>
              </Typography>
              <Grid item xl={12} xs={12} >
              <hr />
            </Grid>
            <Grid container className='comment'>
                  <ContentEditableInfoForNewTask addFileToSystemInfo={addPictureToSystemInfo} setHtml={setSystemIhfoText} systemInfo={systemInfo} />
            </Grid>
            </Grid>
          </>}
      </Grid>
    </Grid>
  </>
})
